import LogoCardsTitle from "../Logo-Cards-Title/LogoCardsTitle";
import { MockImages3 } from "./MockData";
import "./our_logos.css";
import "../Logo-Cards-Container/logo_cards.css";

const OurLogos = () => {
  return (
    <div className="our_logos_container">
      <LogoCardsTitle heading="Our Logos" />
      <div className="our_logos_wrapper no-scrollbar">
        {MockImages3.map((item, index) => (
          <div className="our_logos_card" key={index}>
            <div className="logos_conatainer">
              <img src={item.img} alt="logo_img" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurLogos;
